export default __webpack_public_path__ + "static/media/xo.b894cc80.png";